import { get } from "lodash";
import { useGetProfileQuery } from "~/schemas/generated/graphql";
import { TRole } from "~/types/Routes";

export const checkRole = () => {
  const getProfile = useGetProfileQuery({});
  return get(getProfile, "data.UserGetter.getProfile.role", "");
};

export const checkRoleByList = (lockedFor: TRole[] = []) => {
  const current = checkRole();
  return lockedFor.includes(current as TRole);
};
